<div class="row mt24" *ngLet="allApps$ | async">
  <div #categoriesButton class="row-filter">
    <app-multi-select
      [isVersionImpaired]="true"
      [dropdownMaxHeight]="400"
      [dropdownWidth]="categoriesButton.offsetWidth - 2"
      [options]="appState.categories ?? (categoriesList$ | async)"
      (choose)="onChooseCategories($event)"
      [overlayPosition]="dropDownOverlayPosition"
      (isOpenDropDownChanged)="isActiveCategoryFilter = $event"
    >
      <div class="center">
        <app-button-icon
          [iconName]="isActiveCategoryFilter ? icons.Close : icons.BigTriangleDown"
          [isActive]="isActiveCategoryFilter"
          [classSize]="'big-impaired'"
          buttonName="{{ 'DATA.TABLE_FILTER.CATEGORIES' | translate }} : {{ countSelectCategories }}"
        ></app-button-icon>
      </div>
    </app-multi-select>
  </div>

  <div #platformButton class="row-filter">
    <app-multi-select
      [dropdownMaxHeight]="400"
      [isVersionImpaired]="true"
      [dropdownWidth]="platformButton.offsetWidth - 2"
      [options]="appState.platforms"
      (choose)="onChoosePlatforms($event)"
      [overlayPosition]="dropDownOverlayPosition"
      (isOpenDropDownChanged)="isActivePlatformFilter = $event"
    >
      <div class="center">
        <app-button-icon
          [iconName]="isActivePlatformFilter ? icons.Close : icons.BigTriangleDown"
          [isActive]="isActivePlatformFilter"
          [classSize]="'big-impaired'"
          buttonName="    {{ 'VERSION_VISUALLY_IMPAIRED.OC' | translate }}: {{ countSelectPlatform }}"
        ></app-button-icon>
      </div>
    </app-multi-select>
  </div>
</div>
